(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-promotions"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ergometric-promotions')){
    customElements.define('ergometric-promotions',class extends HTMLElement{
      connectedCallback(){
        this.slides=[...this.querySelectorAll('[data-slide]')];this.tabs=[...this.querySelectorAll('[data-select]')];this.pause=this.querySelector('[data-pause]');this.index=0;this.stopped=matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;this.focused=false;this.abort=new AbortController();const opts={signal:this.abort.signal};
        this.tabs.forEach((b,i)=>b.addEventListener('click',()=>{this.show(i);this.schedule()},opts));
        this.pause?.addEventListener('click',()=>{this.stopped=!this.stopped;this.paintPause();this.schedule()},opts);
        this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule()},opts);this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule()},opts);
        this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},opts);this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule()}},opts);
        document.addEventListener('visibilitychange',()=>this.schedule(),opts);
        this.addEventListener('shopify:block:select',e=>{const i=this.slides.indexOf(e.target.closest('[data-slide]'));if(i>=0){this.stopped=true;this.show(i);this.paintPause();this.schedule()}},opts);
        this.paintPause();this.schedule();
      }
      show(i){this.index=i;this.slides.forEach((s,n)=>{s.classList.toggle('is-active',n===i);s.inert=n!==i;s.setAttribute('aria-hidden',String(n!==i));if(n===i)this.tabs[n].setAttribute('aria-current','true');else this.tabs[n].removeAttribute('aria-current')})}
      paintPause(){if(!this.pause)return;this.pause.setAttribute('aria-label',this.stopped?this.pause.dataset.play:this.pause.dataset.stop);this.pause.firstElementChild.textContent=this.stopped?'▷':'Ⅱ'}
      schedule(){clearTimeout(this.timer);if(!this.stopped&&!this.hovered&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>{this.show((this.index+1)%this.slides.length);this.schedule()},Number(this.dataset.delay)||6500)}
      disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort()}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
